import { InjectionToken } from '@angular/core';

export const AWIN_TRACKING_TEST_MODE = new InjectionToken<boolean>(
  'Awin Tracking Test Mode'
);
